export default __webpack_public_path__ + "static/media/img-3.c801d405.jpg";